'use client';

import type { ReactNode } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import { captureException } from 'utils/errorTracking';

interface TrackingErrorBoundaryProps {
  children: ReactNode;
  fallback: ReactNode;
}

const TrackingErrorBoundary = ({ children, fallback }: TrackingErrorBoundaryProps) => (
  <ReactErrorBoundary
    fallback={fallback}
    onError={(error) => captureException(error, { error_boundary: 'fallback' })}
  >
    {children}
  </ReactErrorBoundary>
);

export default TrackingErrorBoundary;
